import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, money } from "@/lib/api";
import { SavedBy } from "@/admin/Recorded";
import { AdminTitle, Btn, Pill, Table } from "@/admin/AdminLayout";
import { Stars } from "@/components/common";

export default function AdminReviews() {
  const [items, setItems] = useState<any[]>([]);
  const [busy, setBusy] = useState("");
  const load = () => api.get("/admin-x/reviews").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const mod = async (id: string, status: string) => {
    setBusy(id);
    try {
      const r = await api.put(`/admin-x/reviews/${id}`, { status });
      toast(r.data.reward ? `Review approved — ${money(r.data.reward)} Somnio VIP reward credited` : `Review ${status}`); await load();
    } finally { setBusy(""); }
  };
  const del = async (id: string) => { await api.delete(`/admin-x/reviews/${id}`); load(); };
  return (
    <div data-testid="admin-reviews">
      <AdminTitle title="Reviews" sub="Native customer reviews. Approve to publish on product pages." />
      <Table head={["Product", "Rating", "Review", "Author", "Status", ""]} testId="reviews-table">
        {items.map((r) => (
          <tr key={r.id} data-testid={`admin-review-${r.id}`}>
            <td className="px-4 py-3 text-xs">{r.product_name}</td>
            <td className="px-4 py-3"><Stars value={r.rating} size={11} /></td>
            <td className="px-4 py-3 max-w-md"><b>{r.title}</b><div className="text-xs text-neutral-600">{r.body}</div>
              {(r.photos?.length > 0 || r.video) && <div className="flex gap-1.5 mt-2" data-testid={`admin-review-media-${r.id}`}>{(r.photos || []).map((u: string) => <a key={u} href={u} target="_blank" rel="noreferrer"><img src={u} alt="" className="h-12 w-12 object-cover" /></a>)}
                {r.video && <a href={r.video} target="_blank" rel="noreferrer" className="h-12 px-2 flex items-center bg-neutral-900 text-white text-[10px] uppercase">Video</a>}</div>}
              {r.reward && <div className="mt-1"><Pill tone="green">VIP reward {money(r.reward)}</Pill></div>}</td>
            <td className="px-4 py-3 text-xs">{r.author}{r.verified_buyer && <div><Pill tone="green">verified</Pill></div>}</td>
            <td className="px-4 py-3"><Pill tone={r.status === "approved" ? "green" : r.status === "rejected" ? "red" : "amber"}>{r.status}</Pill><SavedBy d={r} testId={`review-saved-${r.id}`} /></td>
            <td className="px-4 py-3 space-x-2 whitespace-nowrap">
              {r.status !== "approved" && <Btn disabled={busy === r.id} onClick={() => mod(r.id, "approved")} data-testid={`review-approve-${r.id}`}>Approve</Btn>}
              {r.status !== "rejected" && <Btn ghost disabled={busy === r.id} onClick={() => mod(r.id, "rejected")} data-testid={`review-reject-${r.id}`}>Reject</Btn>}
              <Btn ghost onClick={() => del(r.id)} data-testid={`review-delete-${r.id}`}>Delete</Btn>
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
